import {useTranslation} from '#imports';
import type {LegalAgreementLanguage} from '@api';
import {sampleVariableValues} from '~/utils/legalAgreementVariables';

export function useLegalAgreementSampleVariableValues() {
    const {getFixedT} = useTranslation();

    return (language: LegalAgreementLanguage) => {
        const translateInContentLanguage = getFixedT(language.toLowerCase());
        return sampleVariableValues(language, (date) => translateInContentLanguage('compliance.legal.agreement.signed.on', [date]));
    };
}
